import { render, staticRenderFns } from "./header.vue?vue&type=template&id=2c9b3962&scoped=true&"
import script from "./header.ts?vue&type=script&lang=ts&"
export * from "./header.ts?vue&type=script&lang=ts&"
import style0 from "./header.less?vue&type=style&index=0&id=2c9b3962&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9b3962",
  null
  
)

export default component.exports